import HeaderNotifications from './header_notifications'
import AddObjectDropdown from './add_object_dropdown'
import Tooltip from './tooltip'
import { handleMissingAvatar } from './shared_functions'
import UserStatusIcon from './user_status_icon'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      settingsDropVisible: false,
      hammerInitialized: false,
      timetrackerSpacerWidth: window.mobileLayout ? 80 : 96,
      linksWidth: [],
      hiddenLinks: 0,
      mobileNavVisibile: false,
      mobileNav: 'content',
      headerNotifications: false,
      dropdownVisible: false,
      openedNavs: [],
      userStatus: props.userStatus || '',
      reload: false
    }

    this.navTimeouts = {}
    this.handleWindowMessageWrapper = this.handleWindowMessage.bind(this)
  }

  componentDidMount() {
    let _this = this
    $(document).click(function (e) {
      if (!window.mobileLayout && !window.tabletLayout) {
        if (!$(e.target).hasClass('preventAutoClose') && _this.state.settingsDropVisible) {
          _this.setState({ settingsDropVisible: false })
        }
      }
    })

    // Add window resize listener
    window.addEventListener('resize', (e) => {
      _this.setLinksWidth()
      _this.hideLinks()
    })

    if (this.state.reload) {
      this.setState({reload: false})
    }

    window.addEventListener('message', _this.handleWindowMessageWrapper)
  }

  componentWillUnmount() {
    let _this = this
    window.removeEventListener('message', _this.handleWindowMessageWrapper)
  }

  componentDidUpdate(prevProps, prevState) {
    // Caretize
    if (
      (!prevProps.data.user_email && this.props.data.user_email) ||
      (prevProps.data.navigation_links &&
        prevProps.data.navigation_links.filter((i) => i.visible).length !=
          this.props.data.navigation_links.filter((i) => i.visible).length &&
        this.props.data.user_email)
    ) {
      this.setLinksWidth()
    }

    // Body mobile nav
    if (this.state.mobileNavVisibile) {
      document.querySelector('html').classList.add('nav-opened')
      document.querySelector('body').classList.add('nav-opened')
    } else {
      document.querySelector('html').classList.remove('nav-opened')
      document.querySelector('body').classList.remove('nav-opened')
    }
    document.querySelector('body').classList.remove('content')
    document.querySelector('body').classList.remove('functions')
    document.querySelector('body').classList.add(this.state.mobileNav)
  }

  handleWindowMessage(e) {
    if (!e.data || !e.data.type) return
    switch (e.data.type) {
      case 'reload_header':
        this.setState({
          reload: true
        })
        break
      default:
        return
    }
  }

  setLinksWidth() {
    // Count nav links width
    var linksWidth = []

    // Let's support stupid browsers
    var links = document.querySelectorAll('header div.nav > ul > li:not(.hidden-links)')
    for (var i = 0, len = links.length; i < len; i++) {
      linksWidth.push(links[i].offsetWidth)
    }
    this.setState({ linksWidth: linksWidth }, () => {
      this.hideLinks()
    })
  }

  hideLinks(width = undefined) {
    if (window.mobileLayout) {
      this.setState({ hiddenLinks: 0 })
    } else {
      var totalWidth = this.state.linksWidth.reduce((a, b) => a + b, 0)
      var headerNav = document.querySelector('header div.nav')
      var navWidth = headerNav ? headerNav.offsetWidth - 32 : null

      if (navWidth && navWidth <= totalWidth) {
        // Shrink
        var newWidth = totalWidth
        var helperIndex = 0
        var linksReverse = this.state.linksWidth.concat().reverse()

        while (newWidth >= navWidth && helperIndex < linksReverse.length) {
          newWidth -= linksReverse[helperIndex]
          helperIndex += 1
        }
        this.setState({ hiddenLinks: helperIndex })
      } else {
        if (this.state.hiddenLinks > 0) this.setState({ hiddenLinks: 0 })
      }
    }
  }

  toggleMobileNav(e) {
    e.preventDefault()
    this.setState({ mobileNavVisibile: !this.state.mobileNavVisibile })
  }

  changeMobileNav(mode, e = null) {
    if (e) e.preventDefault()
    this.setState({ mobileNav: mode })
  }

  toggleHeaderNotifications(e) {
    e.preventDefault()
    this.setState({ headerNotifications: !this.state.headerNotifications })
  }

  toggleDropdown(action = 'toggle', e) {
    if (e) e.preventDefault()
    switch (action) {
      case 'show':
        this.setState({ dropdownVisible: true })
        break
      case 'hide':
        this.setState({ dropdownVisible: false })
        break
      default:
        this.setState({ dropdownVisible: !this.state.dropdownVisible })
    }
  }

  sendGaEvent(name, e) {
    try {
      // To-Do G4 migration
      // ga('send', 'event', 'Sidebar', 'Click', name)
    } catch (err) {
      console.log(err)
    }
  }

  openSearch(e) {
    e.preventDefault()
    window.app.refs.search.setState({ visible: true })
    this.sendGaEvent('search')
  }

  handleMouseEnter(name, e) {
    // let _this = this
    // if (this.navTimeouts[name]) clearTimeout(this.navTimeouts[name])
    // this.navTimeouts[name] = setTimeout(() => {
    //   _this.setState((state, props) => {
    //     return {
    //       openedNavs: state.openedNavs.concat([name])
    //     }
    //   })
    // }, 200)
  }

  handleMouseLeave(name, e) {
    // let _this = this
    // if (this.navTimeouts[name]) clearTimeout(this.navTimeouts[name])
    // this.navTimeouts[name] = setTimeout(() => {
    //   _this.setState((state, props) => {
    //     return {
    //       openedNavs: state.openedNavs.filter(i => i != name)
    //     }
    //   })
    // }, 200)
  }

  toggleSections(name, e) {
    if (
      (e.target.tagName.toLowerCase() == 'a' || (e.target.tagName.toLowerCase() == 'i' && e.target.closest('a'))) &&
      !e.target.classList.contains('root') &&
      !e.target.parentElement?.classList?.contains('icon')
    ) {
      // Follow the link
    } else {
      e.preventDefault()
    }

    if (e.target.tagName.toLowerCase() != 'a' && !e.target.closest('a')) return

    if (this.navTimeouts[name]) clearTimeout(this.navTimeouts[name])
    this.setState((state, props) => {
      return {
        openedNavs: state.openedNavs.includes(name) ? [] : [name]
      }
    })
  }

  changeUserStatus(e) {
    this.setState({userStatus: e.target.value}, () => {
      jQuery.ajax({
        url: this.props.data.api_path + '/users/change_status',
        method: 'POST',
        data: {
          status: e.target.value
        }
      })
    })
  }

  render() {
    var secondary_accounts = []
    if (this.props.data.environment && this.props.data.accounts.length > 1) {
      secondary_accounts = this.props.data.accounts.filter((i) => i.slug != this.props.data.account_slug)
    }

    // Prepare links
    var links = this.props.data?.navigation_links
      ? this.props.data.navigation_links.concat().filter((link) => link.visible)
      : []
    var visibleLinks = []
    var hiddenLinks = []

    if (this.props.data.need_otp) {
      visibleLinks = []
    } else if (this.state.hiddenLinks > 0) {
      var helper = links.length - this.state.hiddenLinks
      hiddenLinks = links.slice(helper, links.length)
      visibleLinks = links.map((link, index) => {
        return {
          ...link,
          shrinked: hiddenLinks.find((ii) => ii.id == link.id)
        }
      })
    } else {
      visibleLinks = links
    }

    if (this.props.data.environment) {
      return (
        <header>
          <div className={classNames('caflou-icon', { 'full-logo': !this.props.menuVisible })}>
            {this.props.menuVisible ? (
              <a href={'/' + this.props.data.account_slug}>
                <img src={this.props.data.icon} alt="Caflou" />
              </a>
            ) : (
              <img src={this.props.data.full_logo_white} alt="Caflou" />
            )}
          </div>

          <div
            className={classNames('nav primary-nav', this.state.mobileNav, {
              visible: this.state.mobileNavVisibile && this.state.mobileNav == 'content',
              'with-opened-section': this.state.openedNavs.length > 0,
              'shared-link-nav': !this.props.menuVisible
            })}
          >
            {this.props.menuVisible && !this.props.headerLinksDisabled ? (
              <ul>
                {visibleLinks.map((i, index) => {
                  if (i.disabled) {
                    return (
                      <li className={classNames('disabled', { shrinked: i.shrinked })} key={index}>
                        <Tooltip content={I18n.t('js.you-have-no-rights-to-this-function')} placement="bottom">
                          <a href="#" id={i.id} onClick={(e) => e.preventDefault()}>
                            {i.name}
                          </a>
                        </Tooltip>
                      </li>
                    )
                  } else {
                    return (
                      <li
                        className={classNames({
                          active: i.active,
                          'with-sections': i.sections?.length || i.links?.length,
                          opened: this.state.openedNavs.includes(i.name),
                          shrinked: i.shrinked,
                          dropdown: i.links?.length
                        })}
                        key={index}
                        onMouseEnter={this.handleMouseEnter.bind(this, i.name)}
                        onMouseLeave={this.handleMouseLeave.bind(this, i.name)}
                        onClick={i.sections?.length ? this.toggleSections.bind(this, i.name) : undefined}
                      >
                        <a
                          href={i.path || '#'}
                          target={i.target}
                          id={i.id}
                          data-toggle={i.links?.length ? 'dropdown' : ''}
                          className="root"
                        >
                          <span className="text">{i.name}</span>
                          <span className="icon">
                            {i.sections?.length || i.links?.length ? <i className="fal fa-angle-down"></i> : null}
                          </span>
                        </a>

                        {i.links?.length ? (
                          <ul className="dropdown-menu">
                            {i.links.map((link, index) => (
                              <li key={index}>
                                <a href={link.path} target={link.target}>
                                  {link.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        ) : null}

                        {i.sections?.length ? (
                          <div className="sections">
                            {i.sections.map((section, index) => (
                              <div key={section.name} className={classNames('section', section.style)}>
                                <div className="icon">
                                  {section.icon ? <img src={section.icon} alt={section.name} /> : null}
                                </div>
                                <div className="text">
                                  <div className="name">
                                    <span className="inner-name">{section.name}</span>
                                  </div>
                                  <div className="links">
                                    {section.links
                                      .map((link) => (
                                        <a
                                          key={link.id}
                                          href={link.path || '#'}
                                          id={link.id}
                                          disabled={link.disabled}
                                          target={link.target}
                                          className={classNames({ disabled: link.disabled, hidden: link.hidden })}
                                        >
                                          {link.name}
                                        </a>
                                      ))
                                      .reduce((prev, curr, index) => [
                                        prev,
                                        <span key={index} className="divider"></span>,
                                        curr
                                      ])}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </li>
                    )
                  }
                })}
                {hiddenLinks.length ? (
                  <li className="hidden-links">
                    <div className="btn-group">
                      <button className="" type="button" data-toggle="dropdown">
                        <span className="caret"></span>
                      </button>
                      <ul className="dropdown-menu">
                        {hiddenLinks.map((i, index) => {
                          if (i.sections?.length) {
                            return i.sections.map((section, index_section) => {
                              let link = section.links.find((i) => i.path && !i.disabled) || {}
                              return (
                                <li key={`${index}_${index_section}`}>
                                  <a href={link.path} target={link.target} id={link.id} data-turbolinks="true">
                                    {section.name}
                                  </a>
                                </li>
                              )
                            })
                          } else if (i.links?.length) {
                            return i.links.map((link, index_link) => {
                              return (
                                <li key={`${index}_${index_link}`}>
                                  <a href={link.path} target={link.target} id={link.id} data-turbolinks="true">
                                    {link.name}
                                  </a>
                                </li>
                              )
                            })
                          } else {
                            return (
                              <li key={index}>
                                <a href={i.path} target={i.target} id={i.id} data-turbolinks="true">
                                  {i.name}
                                </a>
                              </li>
                            )
                          }
                        })}
                      </ul>
                    </div>
                  </li>
                ) : null}
              </ul>
            ) : null}
          </div>

          {this.props.menuVisible ? (
            <div className={classNames('secondary-nav', { visible: this.state.mobileNavVisibile })}>
              <div className="account-select">
                <div className={classNames('btn-group', { dropup: window.mobileLayout })}>
                  <button className="account-select-primary" type="button" data-toggle="dropdown">
                    {this.props.data.account_name_truncated}
                    <span className="caret"></span>
                  </button>
                  <ul className="dropdown-menu">
                    {secondary_accounts.map((i) => (
                      <li key={i.slug}>
                        <a href={'/' + i.slug} data-turbolinks="false">
                          {i.name}
                        </a>
                      </li>
                    ))}
                    {this.props.data.can_create_account && (
                      <li>
                        <a href={this.props.data.new_account_path} data-turbolinks="false">
                          <i className="fa-light fa-plus"></i> {I18n.t('create-new-account')}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {!this.props.data.need_otp ? (
                <div className={classNames('settings btn-group', { dropup: window.mobileLayout })}>
                  <a
                    href="#"
                    className={classNames('preventAutoClose', 'dropdown', {
                      active:
                        location.pathname.indexOf('settings') != -1 ||
                        location.pathname.indexOf('account_users') != -1 ||
                        location.pathname.indexOf('trash') != -1
                    })}
                    data-toggle="dropdown"
                    id="link-toggle-settings"
                  >
                    <i className="fal fa-cog"></i>
                  </a>
                  <ul
                    className={classNames('dropdown-menu', { 'dropdown-menu-right': window.mobileLayout })}
                    data-turbolinks="false"
                  >
                    {this.props.data.can_access_settings ? (
                      <li>
                        <a href={this.props.data.settings_path} data-turbolinks="true" id="link-account-settings">
                          {I18n.t('account_settings')}
                        </a>
                      </li>
                    ) : (
                      <li className="disabled">
                        <Tooltip content={I18n.t('js.you-have-no-rights-to-this-function')} placement="left">
                          <a href="#" id="link-account-settings">
                            {I18n.t('account_settings')}
                          </a>
                        </Tooltip>
                      </li>
                    )}

                    {this.props.data.can_access_users ? (
                      <li>
                        <a href={this.props.data.account_users_path} data-turbolinks="true" id="link-user-management">
                          {I18n.t('user-management')}
                        </a>
                      </li>
                    ) : (
                      <li className="disabled">
                        <Tooltip content={I18n.t('js.you-have-no-rights-to-this-function')} placement="left">
                          <a href="#" id="link-user-management">
                            {I18n.t('user-management')}
                          </a>
                        </Tooltip>
                      </li>
                    )}

                    {this.props.data.can_access_settings ? (
                      <li>
                        <a href={this.props.data.workflow_path} data-turbolinks="true" id="link-workflow-settings">
                          {I18n.t('workflow-management')}
                          <span className="beta with-space">beta</span>
                        </a>
                      </li>
                    ) : (
                      <li className="disabled">
                        <Tooltip content={I18n.t('js.you-have-no-rights-to-this-function')} placement="left">
                          <a href="#" id="link-account-settings">
                            {I18n.t('workflow-management')}
                            <span className="beta with-space">beta</span>
                          </a>
                        </Tooltip>
                      </li>
                    )}

                    {this.props.data.can_access_trash ? (
                      <li>
                        <a href={this.props.data.trash_path} data-turbolinks="true" id="link-trash">
                          {I18n.t('js.trash')}
                        </a>
                      </li>
                    ) : (
                      <li className="disabled">
                        <Tooltip content={I18n.t('js.you-have-no-rights-to-this-function')} placement="left">
                          <a href="#" id="link-trash">
                            {I18n.t('js.trash')}
                          </a>
                        </Tooltip>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          ) : (
            <>
              <div className="mobile-nav mobile-only">
                <a href="#" onClick={this.toggleMobileNav.bind(this)} id="link-burger">
                  <i className="fal fa-bars"></i>
                </a>
              </div>
              <div className={classNames('secondary-nav pr-16', { visible: this.state.mobileNavVisibile })}>
                <a href="/">{I18n.t('sign-in')}</a>
              </div>
            </>
          )}

          {this.props.menuVisible ? (
            <>
              <div className={classNames('third-nav', { visible: this.state.mobileNavVisibile })}>
                <div
                  id="nav_notifications"
                  className={
                    'desktop-only nav-notifications' +
                    (location.pathname.indexOf(this.props.data.notifications_path) != -1 ? ' active' : '') +
                    (this.props.data.unread_notifications > 0 ? ' unread' : '')
                  }
                >
                  {!this.props.data.need_otp ? (
                    <>
                      <a href="#" onClick={this.toggleHeaderNotifications.bind(this)} id="link-toggle-notifications">
                        <i className="fal fa-bell"></i>
                        {this.props.data.unread_notifications > 0 ? (
                          <span className="counter-badge">{this.props.data.unread_notifications}</span>
                        ) : null}
                      </a>
                      <HeaderNotifications
                        key="headerNotifications"
                        ref="headerNotifications"
                        data={this.props.data}
                        visible={this.state.headerNotifications}
                      />
                    </>
                  ) : null}
                </div>

                <div className={classNames('avatar btn-group header-avatar', { dropup: window.mobileLayout })}>
                  <a
                    href={this.props.data.settings_user_path}
                    data-turbolinks="true"
                    data-toggle="dropdown"
                    id="link-toggle-user-settings"
                  >
                    <img src={this.props.data.sidebar.avatar_url} onError={handleMissingAvatar} />
                    <UserStatusIcon userId={this.props.data.user_id} />
                  </a>
                  <ul
                    className={classNames('dropdown-menu special-one right', {
                      'dropdown-menu-right': window.mobileLayout
                    })}
                  >
                    {!this.props.data.need_otp ? (
                      <>
                        <li>
                          <a href={this.props.data.settings_user_path} data-turbolinks="true" id="link-user-settings">
                            {I18n.t('my-profile')}
                          </a>
                        </li>
                        <li>
                          <a
                            href={this.props.data.settings_notifications_path}
                            data-turbolinks="true"
                            id="link-notifications-settings"
                          >
                            {I18n.t('notification-settings')}
                          </a>
                        </li>
                        <li>
                          <a
                            href={this.props.data.settings_personalization_path}
                            data-turbolinks="true"
                            id="link-personalizations-settings"
                          >
                            {I18n.t('personalizations-settings')}
                          </a>
                        </li>
                        <li>
                          <a href={this.props.data.affiliate_path} data-turbolinks="true" id="link-affiliate">
                            {I18n.t('js.affiliate-name')}
                          </a>
                        </li>
                        <li className="divider" role="separator"></li>
                      </>
                    ) : null}

                    {this.props.data.users_statuses_enabled &&
                      this.props.data.account_plan_functions.users_statuses == 'true' &&
                      this.props.data.statuses_settings && this.props.data.statuses_settings.filter(us => us.active != 'false').length ?
                      <>
                        <li>
                          <div className="form-group mb-0 select-status-select">
                            <div className="select-wrapper">
                              <select onClick={(e) => e.stopPropagation()} onChange={this.changeUserStatus.bind(this)} value={this.state.userStatus} name="user_status" className="form-control select">
                                <option value="">{I18n.t('select-status')}</option>
                                {this.props.data.statuses_settings.filter(us => us.active != 'false').map(s =>
                                  <option key={s.codename} value={s.codename}>{s.default ? I18n.t(`status-icons.${s.codename}`) : s.name}</option>
                                )}
                              </select>
                            </div>
                          </div>
                        </li>
                        <li className="divider" role="separator"></li>
                      </> : null
                    }

                    <li>
                      <a
                        className="logout"
                        data-confirm={I18n.t('js.really-sign-out')}
                        rel="nofollow"
                        data-method="delete"
                        href="/log-out"
                        id="link-logout"
                      >
                        {I18n.t('js.log-out')}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mobile-nav mobile-only">
                <a href="#" onClick={this.toggleMobileNav.bind(this)} id="link-burger">
                  <i className="fal fa-bars"></i>
                </a>
                {!this.props.data.need_otp ? (
                  <>
                    <div className={classNames('btn-group btn-block', { open: this.state.dropdownVisible })}>
                      <a href="#" onClick={this.toggleDropdown.bind(this, 'toggle')}>
                        <i className="fa-light fa-plus"></i>
                      </a>
                      <AddObjectDropdown data={this.props.data} />
                    </div>
                    <a href="#" onClick={this.openSearch.bind(this)} title={I18n.t('shortcut') + ': ALT S'}>
                      <i className="fa-light fa-search"></i>
                    </a>
                  </>
                ) : null}
              </div>

              {!this.props.data.need_otp ? (
                <div className="nav-notifications mobile-only">
                  <a href={this.props.data.notifications_path}>
                    <i className="fal fa-bell"></i>
                    <span
                      className={classNames('counter-badge', { hidden: this.props.data.unread_notifications <= 0 })}
                    >
                      {this.props.data.unread_notifications}
                    </span>
                  </a>
                </div>
              ) : null}

              {!this.props.data.need_otp && this.props.timetrackerActive && !this.props.headerLinksDisabled ? (
                <div className="timetracker-spacer" style={{ width: this.state.timetrackerSpacerWidth }}></div>
              ) : null}

              <div
                className={classNames('mobile-nav-wrapper', this.state.mobileNav, {
                  hidden: !this.state.mobileNavVisibile
                })}
              >
                <div className="nav-select">
                  {!this.props.data.need_otp ? (
                    <>
                      <a
                        href="#"
                        className={classNames({ active: this.state.mobileNav == 'content' })}
                        onClick={this.changeMobileNav.bind(this, 'content')}
                      >
                        {I18n.t('main-menu')}
                      </a>
                      <a
                        href="#"
                        className={classNames({ active: this.state.mobileNav == 'functions' })}
                        onClick={this.changeMobileNav.bind(this, 'functions')}
                      >
                        {I18n.t('fast-links')}
                      </a>
                    </>
                  ) : (
                    <a className="visibility-hidden">&nbsp;</a>
                  )}
                </div>
              </div>
            </>
          ) : null}
        </header>
      )
    } else {
      return (
        <header>
          <div className="loading">
            <div className={classNames('progress-spinner-icon', { hidden: this.props.data.environment })}></div>
          </div>
        </header>
      )
    }
  }
}

export default Header
